const TooltipPortalHook = {
    mounted() {
      const el = this.el;
      const tooltipText = el.dataset.tooltip;
      const tooltipTitle = el.dataset.tooltipTitle || "Error";
  
      // Create tooltip div and append to body (escapes all overflow:hidden)
      const tooltip = document.createElement("div");
      tooltip.id = `tooltip-portal-${el.id}`;
      tooltip.style.cssText = `
        position: fixed;
        z-index: 9999;
        width: 420px;
        background: #111827;
        color: #f3f4f6;
        border-radius: 8px;
        padding: 12px;
        font-size: 12px;
        box-shadow: 0 10px 25px rgba(0,0,0,0.4);
        display: none;
        pointer-events: none;
        line-height: 1.6;
        font-family: monospace;
        word-break: break-word;
        white-space: pre-wrap;
      `;
      tooltip.innerHTML = `
        <div style="color: #f87171; font-weight: 600; margin-bottom: 6px; font-family: sans-serif;">
          <span>⚠ ${tooltipTitle}</span>
        </div>
        <div>${tooltipText}</div>
      `;
      document.body.appendChild(tooltip);
  
      const show = (e) => {
        const rect = el.getBoundingClientRect();
        tooltip.style.display = "block";
  
        // Position above the chip, centered
        let left = rect.left + rect.width / 2 - 210; // 210 = half of 420px
        let top = rect.top - tooltip.offsetHeight - 8;
  
        // Clamp to viewport
        left = Math.max(8, Math.min(left, window.innerWidth - 428));
        if (top < 8) top = rect.bottom + 8; // flip below if no room above
  
        tooltip.style.left = `${left}px`;
        tooltip.style.top = `${top}px`;
      };
  
      const hide = () => {
        tooltip.style.display = "none";
      };
  
      el.addEventListener("mouseenter", show);
      el.addEventListener("mouseleave", hide);
      el.addEventListener("mousemove", show); // reposition on move
  
      // Cleanup on destroy
      this._tooltip = tooltip;
      this._show = show;
      this._hide = hide;
    },
  
    destroyed() {
      this.el.removeEventListener("mouseenter", this._show);
      this.el.removeEventListener("mouseleave", this._hide);
      this.el.removeEventListener("mousemove", this._show);
      if (this._tooltip) this._tooltip.remove();
    }
};

export default TooltipPortalHook;